export const STATIC_PAGES = {
  aboutUs: 'the-brand/about-us',
  cookiesPolicy: 'cookies',
  cookiesMoreInfo: 'cookies',
  generalConditions: 'general-conditions',
  privacy: 'privacy',
}
